<template>
  <div id="analyseBar" style="width: 100%;height: 100%"></div>
</template>

<script>
export default {
  name: "trendAnalyseBar",
  props:['trendAnalyseYear','trendAnalyseCount'],
  data(){
    return{
      analyseBar:null,
    }
  },
  created() {
    this.$nextTick(()=>{
      this.getOption()
    })
  },
  methods:{
    getOption(){
      this.analyseBar = this.$echarts.init(document.getElementById('analyseBar'))
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          data: ['成果数', '引用数'],
          top:'3%'
        },
        xAxis: [
          {
            type: 'category',
            data: this.trendAnalyseYear,
            axisPointer: {
              type: 'shadow'
            },
            boundaryGap:true,
            axisTick: {
              alignWithLabel: true
            },
            axisLine:{
              show:true,
              lineStyle:{
                color: ["#999999"]
              }
            }
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '成果数',
            min: 0,
            // max: 30000,
            axisLabel: {
              formatter: '{value}'
            },
            axisTick: {
              show:false
            },
            axisLine:{
              show:false
            },
            splitLine:{
              show:true,
              lineStyle: {
                color:['#999999']
              }
            }
          },
          {
            type: 'value',
            name: '引用数',
            min: 0,
            // max: 25,
            // interval: 5,
            axisLabel: {
              formatter: '{value} '
            },
            axisTick: {
              show:false
            },
            axisLine:{
              show:false
            },
            splitLine:{
              show:true,
              lineStyle: {
                color:['#999999']
              }
            }
          }
        ],
        series: [
          {
            name: '成果数',
            type: 'bar',
            color:'#3D90F7',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: this.trendAnalyseCount.citationCount
          },
          {
            name: '引用数',
            type: 'line',
            color:'#748BD0',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: this.trendAnalyseCount.achievmtCount
          }
        ]
      };
      this.analyseBar.setOption(option)
    }
  }
}
</script>

<style scoped>

</style>
